import Link from "next/link";

/** Textlink mit Pfeil (Kartenkopf rechts), unverändert aus segmented-status-progress-card. */
export function KopfLink({ href, text }: { href: string; text: string }) {
  return (
    <>
      {/* Preline: data-display/data-display-sub-analytics-kpis/data-display-cat-progress-cards/segmented-status-progress-card */}
      <Link
        className="group inline-flex items-center gap-x-1.5 text-start whitespace-nowrap text-[13px] text-muted-foreground-2 rounded-full underline-offset-2 hover:underline focus:outline-hidden focus:underline"
        href={href}
      >
        {text}
        <svg className="shrink-0 size-3.5 group-hover:opacity-100 group-focus:opacity-100 transition duration-300" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path className="lg:opacity-0 lg:-translate-x-1 lg:group-hover:opacity-100 lg:group-hover:translate-x-0 lg:transition" d="M5 12h14" />
          <path className="lg:-translate-x-1.5 lg:group-hover:translate-x-0 lg:transition" d="m12 5 7 7-7 7" />
        </svg>
      </Link>
    </>
  );
}
